"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpirationCalculator = void 0;
const luxon_1 = require("luxon");
class ExpirationCalculator {
    /**
     * Applies a rolling expiration date
     * - Determines rolling duration of years, months, or days
     * - Converts UTC completion date to local timezone
     * - Adds duration offset
     * - Sets time to end of day (local timezone)
     * - Returns in UTC
     * @param startDate
     * @param timezone
     * @param rule
     * @returns UTC Expiration date in ISO format
     */
    static rollingExpiration(startDate, timezone, rule) {
        const rollingDuration = this.getRollingDuration(rule.term, rule.period);
        const localStartDate = luxon_1.DateTime.fromJSDate(startDate, { zone: timezone });
        return localStartDate
            .plus(rollingDuration)
            .endOf('day')
            .toUTC()
            .toJSDate();
    }
    /**
     * Applies a seasonal expiration date given a renewal and expiration window
     * - Converts UTC completion date to local timezone
     * - Calculates renewal date in local timezone
     * - Sets date to season expiration
     * - Adds the appropriate amount of seasons
     * - Sets time to end of day (local timezone)
     * - Returns in UTC
     * @param Date
     * @param timezone
     * @param rule
     * @returns UTC Expiration date in ISO format
     */
    static seasonalExpiration(startDate, timezone, rule) {
        let renewalYearOffset = 0;
        let expirationYearOffset = 0;
        const localStartDate = luxon_1.DateTime.fromJSDate(startDate, { zone: timezone });
        // Edge cases where renewal-expiration range spans a new year
        // Subtract a year when
        if (rule.season.renewal_month > rule.season.expiration_month) {
            if (localStartDate.month >= rule.season.renewal_month &&
                localStartDate.month <= 12) {
                expirationYearOffset = 1;
            }
            else {
                renewalYearOffset = 1;
            }
        }
        const localRenewalDate = luxon_1.DateTime.fromObject({
            year: localStartDate.year - renewalYearOffset,
            month: rule.season.renewal_month,
            day: rule.season.renewal_day,
            zone: timezone
        });
        if (localStartDate < localRenewalDate) {
            expirationYearOffset -= 1;
        }
        return luxon_1.DateTime
            .fromObject({
            year: localStartDate.year + rule.period + expirationYearOffset,
            month: rule.season.expiration_month,
            day: rule.season.expiration_day,
            zone: timezone
        })
            .endOf('day')
            .toUTC()
            .toJSDate();
    }
    /**
     * Helper to transform term + period into Luxon duration
     * @param term
     * @param period
     */
    static getRollingDuration(term, period) {
        switch (term) {
            case 'years':
                return { years: period };
            case 'months':
                return { months: period };
            case 'days':
                return { days: period };
        }
    }
}
exports.ExpirationCalculator = ExpirationCalculator;
